import { v4 as uuidv4 } from 'uuid';
import { runEngine } from '../../../framework/src/RunEngine';
import { IBlock } from '../../../framework/src/IBlock';
import { Message } from '../../../framework/src/Message';
import MessageEnum, {
  getName
} from '../../../framework/src/Messages/MessageEnum';

export default class AssociatedImagesAdapter {
  send: (message: Message) => void;

  constructor() {
    const blockId = uuidv4();
    this.send = message => runEngine.sendMessage(blockId, message);
    runEngine.attachBuildingBlock(this as IBlock, [
      getName(MessageEnum.AssociatedImages)
    ]);
  }

  convert = (from: Message): Message => {
    const to = new Message(getName(MessageEnum.NavigationMessage));

to.addData(
  getName(MessageEnum.NavigationTargetMessage),
  'AssociatedImages'
);

to.addData(
  getName(MessageEnum.NavigationPropsMessage),
  from.getData(getName(MessageEnum.NavigationPropsMessage))
);

// These lines can deleted if we don't need to pass props
const raiseMessage: Message = new Message(
    getName(MessageEnum.NavigationPayLoadMessage)
  );
  raiseMessage.addData(
    getName(MessageEnum.Props),
    from.getData(getName(MessageEnum.Props)) // Insted of Props data we have to use Enum that we have created
  );
  
  to.addData(getName(MessageEnum.NavigationRaiseMessage), raiseMessage);
  // These lines can deleted if we don't need to pass props

return to;
  };

  receive(from: string, message: Message): void {
    this.send(this.convert(message));
  }
}